import { AppRouteProps } from "@bsm/component";
import { BankListContainer } from "./container/BankListContainer";
import { BankCreateRoute } from "./views/create/BankCreateRoute";
import { BankDetailsRoute } from "./views/details/BankDetailsRoute";

export const BankListRoutes: Array<AppRouteProps> = [
    {
        path: 'bank',
        roles: ['INVOICE'],
        element: <BankListContainer />,
        children: [
            ...BankCreateRoute,
            ...BankDetailsRoute
        ]
    }
]